import React, { useRef } from "react";
import "./hero.css";
import devAnimation from "../../animation/dev2.json";
import Lottie from "lottie-react";
import { motion } from "framer-motion";

const circularReplacer = () => {
  const seen = new WeakSet();
  return (key, value) => {
    if (typeof value === "object" && value !== null) {
      if (seen.has(value)) {
        return;
      }
      seen.add(value);
    }
    return value;
  };
};

const Hero = () => {
  const lottieRef = useRef();

  // Charger le contenu JSON du fichier dev2.json
  const jsonString = JSON.stringify(devAnimation, circularReplacer());

  return (
    //  represents a person
    <section
      id="About"
      itemScope
      itemType="http://schema.org/Person"
      className="hero flex"
    >
      <div className="left-section  ">
        <div className="parent-avatar flex">
          <motion.img
            initial={{ transform: "scale(0)" }}
            animate={{ transform: "scale(1.1)" }}
            transition={{ damping: 6, type: "spring", stiffness: 100 }}
            src="./portfoCerc1.png"
            className="avatar"
            alt=""
            itemProp="logo"
          />
          <div style={{ margin: 0 }} className="icon-verified"></div>
        </div>

        <motion.h1
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 2 }}
          className="title motionH1"
          itemProp="jobTitle"
        >
          UX/UI Designer and Web Developer
        </motion.h1>

        <p itemProp="description" className="sub-title">
        I am <span className="gras">Aymane Bouya</span>, an UX/UI Designer and Web Developer with a strong emphasis on intuitive, user-centered design. I strive to create seamless and engaging digital experiences, combining design expertise with web development technical skills.
        </p>

        <div className="all-icons flex">
          <a href="" className="icon icon-twitter" itemProp="sameAs"></a>
          <a href="" className="icon icon-instagram" itemProp="sameAs"></a>
          <a
            // href="https://github.com/BOUYAAYMANE"
            className="icon icon-github"
            itemProp="sameAs"
          ></a>
          <a href="" className="icon icon-linkedin" itemProp="sameAs"></a>
          <a
            href="cv Aymane bouya.pdf"
            className="icon icon-download"
            itemProp="sameAs"
            download
          >
            <i class="fas fa-download"></i>
          </a>
        </div>
      </div>
      {/* animation */}
      <div className="right-section animation ">
        <Lottie
          lottieRef={lottieRef}
          style={{ height: 300 }}
          className=""
          onLoadedImages={() => {
            // kana9so speed dialo
            // https://lottiereact.com/
            lottieRef.current.setSpeed(0.5);
          }}
          animationData={JSON.parse(jsonString)} // Utilisez le contenu JSON sans objets circulaires
          itemProp="image"
        />
      </div>
    </section>
  );
};

export default Hero;
